module.exports = __webpack_public_path__ + "img/extreme.0ce62800.png";